"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequest = void 0;
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const merge_1 = __importDefault(require("lodash/merge"));
const btoa_lite_1 = __importDefault(require("btoa-lite"));
const universal_url_1 = require("universal-url");
const buildUrl = (targetUrl, query, base) => {
    const newUrl = new universal_url_1.URL(targetUrl, base || 'http://example.com');
    if (query) {
        Object.entries(query).forEach(([k, v]) => newUrl.searchParams.append(k, v));
    }
    if (!targetUrl.startsWith('http') && !base) {
        return newUrl.pathname + newUrl.search + newUrl.hash;
    }
    return newUrl.toString();
};
exports.createRequest = ({ ep, config }, { method, params, data, query, baseOpts, opts }) => {
    const customopts = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    if (config.basic) {
        customopts.headers['Authorization'] = `Basic ${btoa_lite_1.default(config.basic.user + ":" + config.basic.password)}`;
    }
    if (config.bearer) {
        customopts.headers['Authorization'] = `Bearer ${config.bearer}`;
    }
    const producedUrl = isFunction_1.default(ep) ? ep(params) : ep;
    const targetUrl = buildUrl(producedUrl, query, config.base);
    return {
        url: targetUrl,
        body: data ? JSON.stringify(data) : undefined,
        method,
        opts: merge_1.default({}, baseOpts, customopts, opts),
    };
};
//# sourceMappingURL=create-request.js.map